import styled from 'styled-components';

export const Loading = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
